import { Box, CircularProgress, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import avatar from '../../../assets/images/proto-verified.png';
import { Title } from '../AuthMethod/styles';

export function ConfirmationAuthMethod(): JSX.Element {
  const [seconds, setSeconds] = useState(5);
  const navigate = useNavigate();

  useEffect(() => {
    if (seconds <= 0) {
      navigate('/home');
    }

    const interval = setInterval(() => {
      setSeconds((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [navigate, seconds]);

  return (
    <>
      <Title style={{ textAlign: 'center' }}>
        O método de autenticação foi ativado
      </Title>
      <img src={avatar} alt="" style={{ width: '250px', height: '250px' }} />
      <span style={{ margin: '16px 0', fontSize: '18px' }}>
        Espere, você está sendo <strong>redirecionado</strong>
      </span>
      <Box position="relative" display="inline-flex">
        <CircularProgress size={80} />
        <Box
          top={0}
          left={0}
          bottom={0}
          right={0}
          position="absolute"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Typography variant="h5" component="div" color="textSecondary">
            {seconds}s
          </Typography>
        </Box>
      </Box>
    </>
  );
}
